import { AnalyticsProvider } from "../../contracts/analytics/analytics";
import mixpanel from "mixpanel-browser";
import CONFIG from "../../core/consts/config";
import { LoggerContract } from "../../contracts/logger/logger";
import AnalyticsEvents from "../../core/consts/analytics-events";

const MixpanelAnalyticsProvider: AnalyticsProvider = (
  logger: LoggerContract
) => ({
  track(event: AnalyticsEvents, context?: any) {
    mixpanel.track(`MyNexar - ${event}`, context);
  },
  reset() {
    try {
      mixpanel.reset();
    } catch (e: any) {
      // @todo review
      logger.Error(e);
    }
  },
  setup() {
    if (CONFIG.MIXPANEL_TOKEN) {
      mixpanel.init(CONFIG.MIXPANEL_TOKEN);
    } else {
      throw new Error("Missing mixpanel token");
    }
  },
  identify(identifier: any) {
    mixpanel.identify(identifier);
    mixpanel.people.set({
      $distinct_id: identifier,
      $name: identifier,
    });
  },
});

export default MixpanelAnalyticsProvider;
